export default __webpack_public_path__ + "static/mobile-hero-9914a0d80fc6fccc5ea46149aec7e780.png";